import { SelectionModel } from "@angular/cdk/collections";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableComponent } from "src/app/table.component";
import { ComprehensiveRequestsService } from "src/services/comprehensive-requests.service";
import { QuoteStatus } from "src/models/comprehensive-quote";
import { RateCard } from "src/models/rate-card";
import { Helpers } from "src/helpers/helpers";
import { ReportService } from "src/services/report.service";
import { AccountService } from "src/services/account.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

export class Customer {
  id: number;
  customerName: string;
  userName: string;
  requestType: string;
  vehicleType: string;
  date: string;
  amount: string;
  status: string;
}

@Component({
  selector: "app-comprehensive-consumer-request",
  templateUrl: "./comprehensive-consumer-request.component.html",
  styleUrls: ["./comprehensive-consumer-request.component.css"],
})
export class ComprehensiveConsumerRequestComponent extends TableComponent<RateCard> {
  pageTitle = "Request";
  error: any;
  displayedColumns: string[] = [
    "id",
    "requestDate",
    "ownerName",
    "email",
    "phoneNumber",
    "carMake",
    "insurer",
    "type",
    "requestStatus",
    "comprehensive",
    "addOn",
    "fees",
    "amount",
    "paymentReference",
    "source",
  ];
  selection = new SelectionModel<any>(true, []);
  status: string = "all";
  search: string = "";
  issueDateFrom: string = "";
  issueDateTo: string = "";
  forAgency: boolean = false;

  constructor(
    requestService: ComprehensiveRequestsService,
    private _reportService: ReportService,
    private router: Router,
    private helper: Helpers,
    private accountService: AccountService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
    super(requestService);
    this.forAgency = this.route.snapshot.data["forAgency"];
    const userType = this.helper.getDecodedAccessToken(
      window.localStorage.token
    ).type;
    if (
      userType.indexOf("LEVEL 0") === 0 ||
      userType.indexOf("LEVEL 1") === 0 ||
      userType.indexOf("LEVEL 2") === 0
    ) {
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            }
          );
        }
      });
    }
  }

  openPurchaseDetail(rateCard: RateCard): void {
    const obj = this.helper.getDecodedAccessToken(
      localStorage.getItem("token")
    );
    if (
      obj.type.indexOf("LEVEL 0") === 0 ||
      obj.type.indexOf("LEVEL 1") === 0 ||
      obj.type.indexOf("LEVEL 2") === 0
    ) {
      if (
        rateCard.status == QuoteStatus.PROCESSED ||
        rateCard.status == QuoteStatus.DELIVERED ||
        rateCard.status == QuoteStatus.DISPATCHED
      ) {
        this.router.navigate(["/comprehensive-orders/" + rateCard.rateCardId], {
          state: {
            rateCard: rateCard,
          },
        });
      }
    } else {
      if (
        rateCard.status == QuoteStatus.PROCESSED ||
        rateCard.status == QuoteStatus.DELIVERED ||
        rateCard.status == QuoteStatus.DISPATCHED
      ) {
        this.router.navigate(
          [
            "/comprehensive-consumer-request/policy-status/" +
              rateCard.rateCardId,
          ],
          {
            state: {
              rateCard: rateCard,
            },
          }
        );
      } else {
        this.router.navigate(
          ["/comprehensive-consumer-request/cr-detail/" + rateCard.rateCardId],
          {
            state: {
              rateCard: rateCard,
            },
          }
        );
      }
    }
  }

  getFees(rateCard: RateCard): number {
    return rateCard.fees.reduce((acc, curr) => acc + curr.amount, 0);
  }

  onSubmit(): void {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  getCount() {
    return this.countService.getCount({
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startPolicyIssueDate: this.issueDateFrom ?? "",
      endPolicyIssueDate: this.issueDateTo ?? "",
      forAgency: this.forAgency,
    });
  }

  getData() {
    let pageSize = this.paginator.pageSize ? this.paginator.pageSize : 10;
    return {
      skip: this.paginator.pageIndex * pageSize,
      take: pageSize,
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startPolicyIssueDate: this.issueDateFrom ?? "",
      endPolicyIssueDate: this.issueDateTo ?? "",
      orderBy: this.sort.active,
      orderByDescending: this.sort.direction === "desc",
      forAgency: this.forAgency,
    };
  }

  downloadReport(isXLS: boolean) {
    const data = {
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startPolicyIssueDate: this.issueDateFrom ?? "",
      endPolicyIssueDate: this.issueDateTo ?? "",
      asXLS: isXLS,
      forAgency: this.forAgency,
    };
    this._reportService.downloadReport(
      "DownloadComprehensivePoliciesReport",
      data
    );
  }
}
